import { FormActions } from "../../components/common/FormActions";
import { createViewAction, formatDateTime } from "../../utils/helpers";
import { URL_INCOMING_REQUESTS } from "../../utils/urls";

export const useIncomingRequests = () => {
  const tableColumns = () => [
    {
      id: "Id",
      header: "Id",
    },
    {
      id: "Method",
      header: "Method",
      filter: {
        type: "text",
      },
    },
    {
      id: "Path",
      header: "Path",
      filter: {
        type: "text",
      },
    },
    {
      id: "StatusCode",
      header: "Status Code",
    },
    {
      id: "ResponseTimeMs",
      header: "Response Time (ms)",
    },
    {
      id: "CallerIp",
      header: "Caller IP",
    },
    {
      id: "CallerAgent",
      header: "Caller Agent",
    },
    {
      id: "CreatedAt",
      header: "Created At",
      filter: {
        type: "date",
      },
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        CreatedAt: formatDateTime(item?.CreatedAt),
        actions: (
          <FormActions
            actions={[createViewAction(URL_INCOMING_REQUESTS, item?.Id)]}
          />
        ),
      };
      return row;
    }),
  ];
  const externalFilters = [];

  const tableTotals = () => {
    return {};
  };

  const viewData = (item: any) => {
    return {
      Id: item?.Id,
      RequestPayload: item?.RequestPayload,
      ResponsePayload: item?.ResponsePayload,
      Method: item?.Method,
      Path: item?.Path,
      StatusCode: item?.StatusCode,
      CallerIp: item?.CallerIp,
      CallerAgent: item?.CallerAgent,
      ResponseTimeMs: item?.ResponseTimeMs,
      CreatedAt: item?.CreatedAt,
    };
  };

  return {
    tableColumns,
    tableData,
    viewData,
    tableTotals,
    externalFilters,
  };
};
